import React from "react";
import Logo from "../Img/logo.png";
import Axios from 'axios'
import Slider from "react-slick";
import moment from 'moment';
import { Link } from 'react-router-dom';


export class MinhasCartelas extends React.Component {
  constructor(props) {
    window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
    super(props);
    var options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false,
      timeZone: 'America/Sao_Paulo'
    };    
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      cartelas: null,
      pedidos: null,
      numeros: [],
      gabaritos: [],
      horario: new Date().toLocaleDateString("pt-BR", options),
      timer: "",
      sac: "99999999999",
      pedidosExpirados: []
    };
    this.reloadPage = this.reloadPage.bind(this)
    this.getGabaritos()
    this.getSAC();
    this.listarCartelasPorCliente();
    this.obterNumerosSorteados();
    this.timer();

   this.getUser()

  }

  logout() {
    window.localStorage.setItem("rotaAtual", "");
    this.props.history.push('/')
  }

  async getGabaritos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("gabaritos/gabaritos-ativos");
      this.setState({ gabaritos: response.data });
    } catch (err) {
      console.log(err);
    }
  }


  async getSAC() {
    try {
        var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
        const response = await axiosInstance.get("parametros/get-sac");
        this.setState({sac: response.data.contatoSAC});
    } catch (err) {
        console.log(err);
    }
}
  async obterNumerosSorteados(e) {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("parametros/obter-numeros-sorteados", {});
      this.setState({ numeros: response.data })
    } catch (err) {
      console.log(err);
    }
  }

  marcarCartela(cartela, index) {
    var isValid1 = 0;
    var isValid2 = 0;
    var isValid3 = 0;
    var isCruzadinha = false;
    var isCheia = false;
    this.state.gabaritos.map(gabarito => {
      if (gabarito.tipo == 'Linha' && cartela.codigo == gabarito.cartelaSorteada.codigo) {

        gabarito.numeros.map(gNumero => {
          cartela.numeros.slice(0, 5).map(cNumero => {
            if (cNumero == gNumero)
              isValid1++;
          })
          cartela.numeros.slice(5, 10).map(cNumero => {
            if (cNumero == gNumero)
              isValid2++;
          })
          cartela.numeros.slice(10, 15).map(cNumero => {
            if (cNumero == gNumero)
              isValid3++;
          })
        })
      }

      else if (gabarito.tipo == 'Cruzadinha' && cartela.codigo == gabarito.cartelaSorteada.codigo) {
        gabarito.numeros.map(gNumero => {
          cartela.numeros.slice(0, 5).map(cNumero => {
            if (index == 2 && isValid2 >= 4 && gNumero == cNumero) {
              isCruzadinha = true
            }
          })
          cartela.numeros.slice(5, 10).map(cNumero => {
            if (index == 12 && isValid2 >= 4 && gNumero == cNumero) {
              isCruzadinha = true
            }
          })
        })
      }
      else if (gabarito.tipo == 'Cheia' && cartela.codigo == gabarito.cartelaSorteada.codigo) {
        isCheia = true;
      }

    })
    if (isCheia) return true
    if (isCruzadinha) return true
    if (index < 5 && isValid1 >= 4) {
      return true;
    }
    else if (index >= 5 && index < 10 && isValid2 >= 4) {
      return true;
    }
    else if (index >= 10 && index < 15 && isValid3 >= 4) {
      return true;
    }

    return false;

  }

  conferirColorir(cartelaNumero, cartelaIndex) {
    var status = false;
    if (this.state.numeros.length > 0) {
      status = this.state.numeros.some(numero => numero == cartelaNumero)
    }
    if (status) {
      var classe = "text-light bg-danger col";

      return classe
    }
    else {
      return "col"
    }
  }
  async getUser(){
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.post("usuarios/user", {
        id: this.state.user._id
      });
      this.setState({ user: response.data});
      console.log(response.data)
    } catch (err) {
      console.log(err);
    }
  };



  listarCartelasPorCliente = async e => {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl'),
      });
      const response = await axiosInstance.post("pedidos/listar-pedidos", {
        id: this.state.user._id
      });
      this.setState({ pedidos: response.data })
    } catch (err) {
      console.log(err);
    }
  };

  reloadPage() {
    window.location.reload()
  }


  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }

  async reload() {
    await window.location.reload()
  }

 timer(){
    var countDownDate = new Date("Jan 5, 2022 15:37:25").getTime();

    var x = setInterval(this.interval.bind(this), 1000);
  }


  async interval(){
        this.setState({timer : new Date().toLocaleTimeString()})
  }

  getFinalTime(data,pedido){

    var novaData = new Date(data.getFullYear(), data.getMonth(), data.getDate(), data.getHours() + 2, data.getMinutes(), data.getSeconds(), data.getMilliseconds());
    var distance = new Date(novaData.getTime() - new Date().getTime());

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    if(!pedido.validado && distance < 1 && !this.state.pedidosExpirados.includes(pedido.codigo)){
    // this.desativarPedido(pedido.codigo)
      this.state.pedidosExpirados.push(pedido.codigo)
      this.setState(this.state.pedidosExpirados)
    }

    return hours + "h "+ minutes + "m " + seconds+ "s "
  }


  async desativarPedido(codigo) {
    try {
        var axiosInstance = new Axios.create({
            baseURL: window.localStorage.getItem('apiUrl')
        })
        const response = await axiosInstance.post('pedidos/desativar-pedido', {
            codigo: codigo
        })
        alert('Alguns pedidos expiraram o tempo para validação! Fale com seu cambista responsavel.')
        window.location.reload()
    } catch (err) {
        console.log(err)
    }
    this.listarPedidos()
}

  render() {


    const removeToggled = (e) => {
      window.localStorage.setItem("rotaAtual", e.target.name);
      setTimeout(this.reload, 100)
    }
    const screenWidth = this.state.screenWidth >= 960 ? 3 : 1;
    var settings = {
      dots: false,
      infinite: false,
      speed: 1,
      slidesToShow: screenWidth,
      slidesToScroll: 1,
    };

    const logout = () => {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem("rotaAtual");
      window.location.href = '/'
    }

    return (
      <div>
        <div className="wrapper">
          <div className="sidebar" data-image="/assets/img/sidebar-5.jpg">
            <div className="sidebar-wrapper">
              <div className="logo">
                <img src={Logo} style={{ width: '10em', height: '4em' }} />
              </div>

              <ul className="nav">
                <li className="nav-item">
                  <Link onClick={logout} className="nav-link" >
                    <i className="fas fa-sign-out-alt"></i>
                    <span>SAIR</span>
                  </Link>
                </li>
                <li className="nav-item active">
                  <Link className="nav-link" to="minhas-cartelas" name="minhas-cartelas" onClick={removeToggled.bind(this)}>
                    <i className="nc-icon nc-layers-3" />
                    <p>Minhas cartelas</p>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="loja-cliente" name="loja-cliente" onClick={removeToggled.bind(this)}>
                    <i className="nc-icon nc-istanbul" />
                    <p>Loja</p>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="ganhadores" name="ganhadores" onClick={removeToggled.bind(this)}>
                    <i className="nc-icon nc-satisfied" />
                    <p>ult. ganhadores</p>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="perfil-cliente" name="perfil-cliente" onClick={removeToggled.bind(this)}>
                    <i className="nc-icon nc-circle-09" />
                    <p>Perfil</p>
                  </Link>
                </li>
                <li style={{padding: '8px'}}>
                  <Link style={{border: '3px solid white', borderRadius: '6px'}} class="nav-link"  name="aplicativo" onClick={() => {window.location.href = "https://www.sorteflash.com/download/sorteflash-app.apk"}}>
                    <i class="fa fa-android"></i> 
                    <p>Novo aplicativo</p>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="main-panel">
            <nav className="navbar navbar-expand-lg " color-on-scroll="500">
              <div className="container-fluid">
                <button className="btn-fill btn btn-warning" onClick={this.reloadPage}><i className="fa fa-refresh" aria-hidden="true"></i></button>
                <button
                  to=""
                  className="navbar-toggler navbar-toggler-right"
                  type="button"
                  data-toggle="collapse"
                  aria-controls="navigation-index"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-bar burger-lines"></span>
                  <span className="navbar-toggler-bar burger-lines"></span>
                  <span className="navbar-toggler-bar burger-lines"></span>
                </button>
                <div
                  className="collapse navbar-collapse justify-content-end"
                  id="navigation"
                >
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                      <a className="nav-link">
                        <span className="no-icon">{window.screen.width >= 600 ? "Olá, " + this.state.user.perfil.toLowerCase() + " " + this.state.user.nome : "Olá, " + this.state.user.nome}</span>
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <Link className="nav-link" onClick={this.logout}>
                        <span className="no-icon">Sair</span>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </nav>
            <div className="content">
              <div className="container-fluid">
                <div className="bg-dark">
                  {this.state.pedidos ? <h5 className="text-center text-warning p-2">Envie o código do pedido para um vendedor Sorteflash, caso não tenha o contato do vendedor clica em Precisa de Ajuda.</h5> :
                    <h5 className="text-center text-warning p-2">Você não possui nenhum pedido.</h5>}
                </div>
                <a className="mt-3" href={'https://api.whatsapp.com/send?phone=55'+this.state.sac+'&text=Preciso de ajuda'}>
                    <div>
                        <i className="fas fa-info-circle"></i>
                        <span className="ml-3">Precisa de ajuda?</span>
                    </div>
                </a>
                {this.state.pedidos != null ? this.state.pedidos.map(pedido => {
                  return <div id={pedido.codigo} className="accordion bg-black-50 shadow-lg rounded">

                    <div className="card p-2"  >
                      <div className="card-header" id={pedido.codigo + "headingOne"}>
                        <button className="btn btn-link bg-dark rounded container p-2 collapsed" type="button" data-toggle="collapse" data-target={"#" + pedido.codigo + "collapseOne"} aria-expanded="true" aria-controls={pedido.codigo + "collapseOne"}>
                          <div className="row">
                            <div className="col-sm">
                              <h5 className="text-center">
                                <a className="text-info">Pedido: </a>
                                <input disabled className="bg-dark ml-1 text-light" style={{ border: 'none' }} value={pedido.codigo}></input>
                              </h5>
                            </div>
                            <div className="col-sm">
                              <h5 className="text-center">
                                <a className="text-info">Total:  </a>
                                <a className="ml-1 text-light">{"R$: " + pedido.cartelas.reduce((acumulador, cartela) => acumulador += parseFloat(cartela.valor), 0).toFixed(2)
                                }</a>
                              </h5>
                            </div>
                            <div className="col d-flex justify-content-center">
                              {/* <a className={this.state.user.tutorId == "5e5c5ca4cc7aa938f0b47ff8" ? "btn-fill btn btn-success" : "d-none"} href={'https://api.whatsapp.com/send?phone=558681789900&text=Pedido: ' + pedido.codigo + ' Valor: R$:' + pedido.cartelas.length * pedido.cartelas[0].valor + ' Cliente: ' + pedido.clienteId.nome + ' Data: '+ this.state.horario}><i className="fa fa-whatsapp" aria-hidden="true"></i>Efetuar pagamento</a>
                              <a className={this.state.user.tutorId != "5e5c5ca4cc7aa938f0b47ff8" ? "btn-fill btn btn-success" : "d-none"} href={`https://api.whatsapp.com/send?phone=55${this.state.user.tutorId.telefone.replace(" ","").replace(" ","")}&text=Pedido:` + pedido.codigo + ' Valor: R$:' + pedido.cartelas.length * pedido.cartelas[0].valor + ' Cliente: ' + pedido.clienteId.nome + ' Data: '+ this.state.horario}><i className="fa fa-whatsapp" aria-hidden="true"></i>Efetuar pagamento</a> */}
                              {!this.state.pedidosExpirados.includes(pedido.codigo)? <a className="btn-fill btn btn-success" href={`https://api.whatsapp.com/send?text=Sorteflash: Pedido: ` + pedido.codigo + ' Valor: R$:' + pedido.cartelas.length * pedido.cartelas[0].valor + ' Cliente: ' + pedido.clienteId.nome}><i className="fa fa-whatsapp" aria-hidden="true"></i>Validar pedido</a> : ''}
                            </div>
                          </div>
                          <div className="row p-2">
                            <div className="col justify-content-center font-weight-bold">
                              {pedido.recebido ?
                                <span className="text-success">
                                  Pagamento recebido por {pedido.cambistaId.nome}
                                </span>
                                :
                                !this.state.pedidosExpirados.includes(pedido.codigo)?  
                                <span className="text-warning">
                                    Aguardando pagamento
                                </span>
                                 : ''
                                //  <span className="text-danger"> Pedido expirado, faça outro pedido</span>
                                }
                            </div>
                            <div className="col justify-content-center font-weight-bold">
                              {pedido.validado ?
                                <span className="text-success">
                                  Validado para sorteio
                                </span>
                                :
                                <span className="text-warning">
                                  {!this.state.pedidosExpirados.includes(pedido.codigo)?  'Aguardando validação' : ''}
                                </span>}
                            </div>
                            <div className="col justify-content-center font-weight-bold">
                                <span className={!this.state.pedidosExpirados.includes(pedido.codigo)? "text-white" : "d-none" }>
                                {/* Expirará em: {this.getFinalTime(new Date(pedido.data), pedido)} */}
                                </span>
                            </div>
                          </div>

                        </button>

                      </div>

                      <div id={pedido.codigo + "collapseOne"} className="collapse" aria-labelledby={pedido.codigo + "headingOne"} data-parent={"#" + pedido.codigo}>
                        <div className="card-body sliderAjust" >
                          <Slider className={"w-100"} {...settings}>

                            {pedido.cartelas ?
                              pedido.cartelas.map((cartela, index) => {
                                return (
                                  <button
                                    className="superContainer p-2 "
                                    onClick={this.selecionar}
                                    name={index}
                                    key={index}
                                  >
                                    <div
                                      id={"item-" + index}
                                      className="card text-white bg-dark mb-3 shadow"
                                    >

                                      <div className="bg-dark card-header ">
                                        <div className="container ">
                                          <div className="row">
                                            <div className="col">
                                              <div className="row">
                                                <span className="font-weight-bold">
                                                  código : <Link className="text-danger">{cartela.codigo}</Link>
                                                </span>
                                              </div>
                                              <div className="row">
                                                <span className="font-weight-bold text-warning">
                                                  Data do sorteio : <Link className="text-light">{this.formatDate(cartela.data)}</Link>
                                                </span>
                                              </div>
                                            </div>
                                            <div className="col">
                                              <div className="row justify-content-end">
                                                <span className="font-weight-bold">
                                                  lote: <Link className="text-danger">  {pedido.loteId ? pedido.loteId.codigo : "0"}</Link>
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                      </div>

                                      <div className="bg-dark card-body justify-content-center ajustar">
                                        <div
                                          className="bg-light rounded"
                                          style={{ width: "17.8em", height: "10em" }}

                                        >
                                          {cartela.numeros ?

                                            <div className="container text-dark tracado">
                                              <div className="row">
                                                <div className="col">
                                                  <span >{cartela.numeros[0]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[1]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[2]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[3]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[4]}</span>
                                                </div>
                                              </div>
                                              <div className="row">
                                                <div className="col">
                                                  <span>{cartela.numeros[5]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[6]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[7]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[8]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[9]}</span>
                                                </div>
                                              </div>
                                              <div className="row">
                                                <div className="col">
                                                  <span>{cartela.numeros[10]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[11]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[12]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[13]}</span>
                                                </div>
                                                <div className="col">
                                                  <span>{cartela.numeros[14]}</span>
                                                </div>
                                              </div>
                                            </div>

                                            : ""}
                                        </div>
                                      </div>
                                    </div>
                                    <span
                                      id={"sel-tit-" + index}
                                      className="collapse font-weight-bold text-success"
                                    >
                                      Selecionado
                                    </span>
                                  </button>


                                );
                              })
                              : ""}
                          </Slider>
                        </div>
                      </div>
                    </div>


                  </div>

                }) : ""}
              </div>
            </div>
            <footer className="footer">
              <div className="container-fluid">
                <nav>
                  <ul className="footer-menu">
                    <li>
                      <Link to="#">Empresa</Link>
                    </li>
                    <li>
                      <Link to="#">Regulamento</Link>
                    </li>
                    <li>
                      <Link to="#">Outros projetos</Link>
                    </li>
                  </ul>
                  <p className="copyright text-center">
                    Proprietário ©
                    <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                  </p>
                </nav>
              </div>
            </footer>

          </div>
        </div>
      </div>
    );
  }
}

export default MinhasCartelas;
